module.exports = __webpack_public_path__ + "static/img/lenovoTab8.9fd4d5b9.png";